// Navegação entre nós no modal "Editar nó": vizinhos pelas ligações e uma ordem
// estável do fluxo (das entradas seguindo as ligações; nós soltos por posição).

const byPosition = (a, b) =>
  (a.position?.y || 0) - (b.position?.y || 0) ||
  (a.position?.x || 0) - (b.position?.x || 0);

const uniqueNodes = list => {
  const seen = new Set();
  return list.filter(node => {
    if (!node || seen.has(node.id)) return false;
    seen.add(node.id);
    return true;
  });
};

export const incomingNodes = (nodes, edges, nodeId) =>
  uniqueNodes(
    (edges || [])
      .filter(edge => edge.target === nodeId)
      .map(edge => (nodes || []).find(node => node.id === edge.source))
  );

export const outgoingNodes = (nodes, edges, nodeId) =>
  uniqueNodes(
    (edges || [])
      .filter(edge => edge.source === nodeId)
      .map(edge => (nodes || []).find(node => node.id === edge.target))
  );

export const orderedFlowNodes = (nodes = [], edges = []) => {
  const ordered = [];
  const visited = new Set();
  const queue = nodes.filter(node => node.type === 'trigger').sort(byPosition);

  while (queue.length) {
    const current = queue.shift();
    if (!visited.has(current.id)) {
      visited.add(current.id);
      ordered.push(current);
      queue.push(
        ...outgoingNodes(nodes, edges, current.id)
          .filter(node => !visited.has(node.id))
          .sort(byPosition)
      );
    }
  }

  const rest = nodes.filter(node => !visited.has(node.id)).sort(byPosition);
  return [...ordered, ...rest];
};

export const adjacentFlowNode = (nodes, edges, nodeId, step) => {
  const ordered = orderedFlowNodes(nodes, edges);
  const index = ordered.findIndex(node => node.id === nodeId);
  if (index < 0) return null;
  return ordered[index + step] || null;
};
